<template>
	<!-- 필터 -->
	<div class="filter">
		<div :class="[`inner grid-col-${cateMain.length > 4 ? 4 : cateMain.length < 2 ? 2 : cateMain.length}`]">
			<!-- 첨 : grid-col-2의 숫자를 col-box 의 갯수만큼 2,3,4로 변경 -->
			<!-- 변경 : grid-col 숫자를 카테고리 개수만큼 자동 기입-->
			<!-- category -->
			<template v-for="(cateMainNum, cateMainName) in (cateMain.length)">
				<div class="col-box" :key="cateMainName">
					<label>{{ cateMain[cateMainName] }}</label>
					<select @change="setCateParam($event, cateMainNum)" id="cateContent">
						<option :value=10>{{ cateMain[cateMainName] }}{{ postposition[cateMainName] }} 선택해 주세요.</option>
						<template v-for="(cateContent, cateContentNum) in cateContent[cateMainNum - 1]">
							<option :value="[`${cateContent[1]}`]" :key="cateContentNum">
								<template v-for="x in (cateContent[1].length - 4)">&nbsp;&nbsp;</template>
								{{ cateContent[0] }}
							</option>
						</template>
					</select>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import '@/components/shop/appShop';
import webUtils from "@/commons/utils/web.utils";

export default {
	name: "codeSelector",
	props: {
		cateCode: String,
		codeNameList: String,
	},
	data() {
		// 파라미터
		var params = this.pageUtils.Params();
		// 카테고리 대분류 + 카테고리 컨텐츠
		var allCate = new Map();
		// 카테고리 대분류
		var cateMain = [];
		// 카테고리 컨텐츠
		var cateContent = [[]];
		// 조사
		var postposition = [];
		// 각 카테고리 별 코드
		var code = [];
		return {
			params,
			allCate: allCate,
			cateMain: cateMain,
			cateContent: cateContent,
			postposition: postposition,
			code: code,
		}
	},

	mounted() {
		this.getCodeList();
	},

	methods: {
		// 카테고리를 Map 에 저장
		putListInMap(self) {
			for (var i = 0; i < self.length; i++) {
				this.allCate.set(self[i].code, self[i].codeName);
				if (self[i].children.length !== 0)
					this.putListInMap(self[i].children);
				this.putListInMap(self[i]);
			}
		},

		getCodeList() {

			this.axiosCaller.get(this, this.APIs.SHOP_GOODS + "/filterCode", {
				cateCode: this.cateCode
			}, (res) => {
				var result = res.data
				if (result.status === "ok") {

					var self = result.category_all;
					// 카테고리를 Map 에 저장 하는 함수를 호출
					this.putListInMap(self);
					var mainCateCount = 0;
					// Map 에 저장된 카테고리를 Array 에 대분류, 소분류 나눠 저장
					this.allCate.forEach((value, key) => {
						if (key.length === 4) {
							mainCateCount++;
							this.cateMain.push(value);
							this.cateContent.push([mainCateCount]);
						} else {
							this.cateContent[mainCateCount].push([value, key]);
						}
					})
					// Array 정리
					this.cateContent.shift();
					for (var i = 0; i < this.cateContent.length; i++) {
						this.cateContent[i].shift()
					}
					// 카테고리 대분류 이름에 따라 을/를 조사 판별
					this.getConstantVowel(this.cateMain);
					// code1, code2, code3... 할당
					for (var j = 1; j < this.cateMain.length + 1; j++) {
						if (this.$route.query[JSON.parse(this.codeNameList)[j - 1]] != null) {
							this.params[JSON.parse(this.codeNameList)[j - 1]] = (this.$route.query[JSON.parse(this.codeNameList)[j - 1]]).slice(0, 2).indexOf(this.cateCode) !== -1 ?
								this.$route.query[JSON.parse(this.codeNameList)[j - 1]] :
								this.cateCode
						}
					}

					console.log('load fn')

					// 파라미터 값에 대응하는 option 태그에 selected 속성 삽입
					this.setSelectedAttribute();

				} else {
					this.swalUtils.gritter("Error", result.msg, "error")
						.then(() => {
							location.href = document.referrer
						})
				}
			});

		},

		// option 선택 시 카테고리에 부합하는 아이템 불러오기
		setCateParam(e, num) {
			for (var i = 1; i < this.cateMain.length + 1; i++) {
				if (num === i)
					this.params[JSON.parse(this.codeNameList)[i - 1]] = e.target.value
			}
			this.$router.push({
				query: this.params,
			}).catch(() => {
			})
			this.$emit('getItem');
		},

		// 파라미터 값에 대응하는 option 태그에 selected 속성 삽입
		setSelectedAttribute() {
			this.$nextTick(() => {
				for (var i = 1; i < this.cateMain.length + 1; i++) {
					!(webUtils.getParameterInt(JSON.parse(this.codeNameList)[i - 1]) == 0 || webUtils.getParameterInt(JSON.parse(this.codeNameList)[i - 1]) == null) ?
						$('.col-box #cateContent').eq(i - 1).val(webUtils.getParameterInt(JSON.parse(this.codeNameList)[i - 1])) : {}
				}
			});
		},

		// 을/를 조사 판별
		getConstantVowel(kor) {
			const t = ['', 'ㄱ', 'ㄲ', 'ㄳ', 'ㄴ', 'ㄵ', 'ㄶ',
				'ㄷ', 'ㄹ', 'ㄺ', 'ㄻ', 'ㄼ', 'ㄽ', 'ㄾ',
				'ㄿ', 'ㅀ', 'ㅁ', 'ㅂ', 'ㅄ', 'ㅅ', 'ㅆ',
				'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'];
			for (var i = 0; i < kor.length; i++) {
				let tn = parseInt(((kor[i]).substr(kor[i].length - 1, 1).charCodeAt(0) - 44032) % 28);
				t[tn] !== "" ? this.postposition[i] = '을' : this.postposition[i] = '를'

			}
		},
	},
}
</script>

<style scoped>
option {
}
</style>